export var STOCK_APPROVAL_PHASE;
(function (STOCK_APPROVAL_PHASE) {
    STOCK_APPROVAL_PHASE["\uBBF8\uD655\uC778"] = "\uBBF8\uD655\uC778";
    STOCK_APPROVAL_PHASE["\uBBF8\uC2B9\uC778"] = "\uBBF8\uC2B9\uC778";
    STOCK_APPROVAL_PHASE["\uC2B9\uC778"] = "\uC2B9\uC778";
    STOCK_APPROVAL_PHASE["\uBC18\uB824"] = "\uBC18\uB824";
})(STOCK_APPROVAL_PHASE || (STOCK_APPROVAL_PHASE = {}));
